import { useState } from "react";
import { Link, LoaderFunctionArgs, useLoaderData, useRevalidator } from "react-router-dom";
import { useUiStore } from "src/components/main/uiStore";
//-------------------------------------------------
import {
    myAxios, 
    defaultPath,
} from "src/components/common/functions";
//-------------------------------------------------
type item = {path: string, content: string}
export default function ErrorLog(){
    const revalidator = useRevalidator();
    const splitContent = (content:string) => {
        const output = content.split("\n");
        if(output.at(-1) === "") output.pop();
        return output;
    }
    const setShowLoader = useUiStore(state => state.setShowLoader);
    //-------------------------------------------------
    const [rootPath, setRootPath] = useState("");
    const data = useLoaderData();
    const [filterWords, setFilterWords] = useState("");
    const filteredData = data.filter((item: item) => filterWords === ""?true:JSON.stringify(item).toLowerCase().includes(filterWords));
    //-------------------------------------------------
    const highlightLinks = (content: typeof data.content) => {
        const regex = /\/home4\/liux3216\/api\.junliu\.space\/.*?\.php/g;
        const parts = content.split(regex);
        const matches = content.match(regex);
        const result = [];
        for(let i = 0; i < parts.length; i++){
            result.push(parts[i]); // Add plain text
            if(matches && matches[i]){
                // Add highlighted URL
                result.push(
                <Link key = {i} to = {`/FileExplorer?path=${matches[i].replace(defaultPath, "")}`}>
                    {matches[i]}
                </Link>
                );
            }
        }
        return result;
    }
    const highlightFolderPath = (content: typeof data.content) => {
        const folderPath = content.split("/").slice(0, -1).join("/");
        const filePath = content.split("/").slice(-1).join("/");
        const result = [];
        result.push(
            <Link key = {folderPath} to = {`/FileExplorer?path=${folderPath.replace(defaultPath, "")}`}>
                {folderPath}
            </Link>
            );
        result.push("/" + filePath);
        return result;
    }
    //-------------------------------------------------
    return (
        <div className = "cssContent pb8rem">
            <nav className = "d-flex align-items-center mt-2 mb-4">
                <span className = "me-3">
                    <label
                        children = "Search"
                        htmlFor = "search"
                        className = "me-2"
                    />
                    <input
                        id = "search"
                        className = "form-control inline w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                        }}
                    />
                </span>
                <span>
                    <label htmlFor = "path">Path:</label>
                    <select
                        id = "path"
                        className = "form-control inline w-auto ms-2"
                        value = {rootPath}
                        onChange = {e => {
                            setRootPath(e.currentTarget.value);
                        }}
                    >
                        <option value = {`${defaultPath}`}>Construct Smarter</option>
                        <option value = {""}>All</option>
                    </select>
                </span>
            </nav>
            {!filteredData.length?<div className = "cssLoading">All Good</div>:
            <div className = "user-select-text">
                {filteredData.map((item:item, index:number) => 
                <div key = {index}>
                    <div className = "h5 text-break">
                        {highlightFolderPath(item.path)}
                        <button
                            children = "x"
                            type = "button"
                            className = "ms-2 btn btn-danger"
                            onClick = {async() => {
                                if(!window.confirm("Are you sure to delete this file?")) return;
                                const formData = new FormData();
                                formData.append("action", "delete");
                                formData.append("path", item.path);
                                //------------------------
                                setShowLoader(true);
                                const res = await myAxios({ fileName: "server/error_log.php", formData: formData });
                                setShowLoader(false);
                                if(!res) return;
                                revalidator.revalidate();
                            }}
                        />
                    </div>
                    {item.content?
                    <div className = "cssNotes text-secondary p-2 border rounded">
                        {splitContent(item.content).map((part, partIndex) => 
                        <p
                            key = {partIndex}
                            className = "my-2"
                        >
                            {highlightLinks(part)}
                            <button
                                children = "x"
                                type = "button"
                                className = "ms-2 btn btn-danger"
                                onClick = {async() => {
                                    // if(!window.confirm("Are you sure to delete this line?")) return;
                                    const newContent = [...item.content.split("\n").slice(0, partIndex), ...item.content.split("\n").slice(partIndex + 1)].join("\n");
                                    const formData = new FormData();
                                    formData.append("action", "partDelete");
                                    formData.append("path", item.path);
                                    formData.append("content", newContent);
                                    setShowLoader(true);
                                    const res = await myAxios({ fileName: "server/error_log.php", formData: formData });
                                    setShowLoader(false);
                                    if(!res) return;
                                    revalidator.revalidate();
                                }}
                            />
                        </p>)
                        }
                    </div>
                    :<></>}
                </div>)}
            </div>}
        </div>
    )
}

export async function errorLogLoader({ request }:LoaderFunctionArgs) {
  const url = new URL(request.url);
  const rootPath = url.searchParams.get("rootPath");
  const formData = new FormData();
  formData.append("action", "read");
  formData.append("rootPath", rootPath ?? "");
  const res = await myAxios({
    fileName: "server/error_log.php",
    formData
  });
  if (!res) return;
  return res.data;
}